import axios from "axios";
import { useAuth } from "context/useAuth";
import { useEffect, useState } from "react";
import { useAppSettings } from "context/appsettingsContext";
import ViewMgtDeviceConfigLock from "./ViewMgtDeviceConfigLock";
import ViewMgtDeviceConfigLogs from "./ViewMgtDeviceConfigLogs";
import ViewMgtDeviceConfigMQTT from "./ViewMgtDeviceConfigMQTT";
import ViewMgtDeviceConfigPower from "./ViewMgtDeviceConfigPower";
import ViewMgtDeviceConfigMotion from "./ViewMgtDeviceConfigMotion";
import ViewMgtDeviceConfigNetwork from "./ViewMgtDeviceConfigNetwork";
import ViewMgtDeviceConfigRemotes from "./ViewMgtDeviceConfigRemotes";
import ViewMgtDeviceConfigAutoLock from "./ViewMgtDeviceConfigAutoLock";
import ViewMgtDeviceConfigPanicButtons from "./ViewMgtDeviceConfigPanicButtons";
import ViewMgtDeviceConfigTrackerOnly from "./ViewMgtDeviceConfigTrackerOnly";

export default function ViewMgtDeviceConfig({ deviceId, device }: { deviceId?: string | null | undefined, device?: any | undefined | null }) {
  
    const settings = useAppSettings();
    const { authorisedUser } = useAuth();
    const [ configuration, setConfiguration ] = useState();
    
    useEffect(() => {
        if (!configuration) {
            (async () => {
                try {
                    const response = await axios.get(
                        `${settings.getDeviceConfigurationUrl}?deviceId=${deviceId}`,
                        { headers: { Authorization: `Bearer ${authorisedUser.accessToken}`, 'Content-Type': 'application/json' } }
                    );
                    setConfiguration(response.data);
                } catch (error) {
                    setConfiguration(device?.ConfigurationStatusLog?.configuration);
                    console.error('Failed to get device configuration', error);
                }
            })();
        }
        // eslint-disable-next-line
    }, [configuration, authorisedUser.accessToken, deviceId, settings.getDeviceConfigurationUrl]);
    
    const components = [
        <ViewMgtDeviceConfigTrackerOnly deviceId={deviceId} device={device} />,
        <ViewMgtDeviceConfigLock deviceId={deviceId} device={device} configuration={configuration} />,
        <ViewMgtDeviceConfigLogs deviceId={deviceId} device={device} configuration={configuration} />,
        <ViewMgtDeviceConfigMotion deviceId={deviceId} device={device} configuration={configuration} />,
        <ViewMgtDeviceConfigNetwork deviceId={deviceId} device={device} configuration={configuration} />,
        <ViewMgtDeviceConfigMQTT deviceId={deviceId} device={device} configuration={configuration} />,
        <ViewMgtDeviceConfigPower deviceId={deviceId} device={device} configuration={configuration} />,
        <ViewMgtDeviceConfigAutoLock deviceId={deviceId} device={device} configuration={configuration} />,
        <ViewMgtDeviceConfigRemotes deviceId={deviceId} device={device} configuration={configuration} />,
        <ViewMgtDeviceConfigPanicButtons deviceId={deviceId} device={device} configuration={configuration} />,
    ];

    return (
        <div className="relative w-full">
            <div className="container mx-auto">
                {components.map(x => <div className="pb-4">{x}</div>)}
            </div>
        </div>
    );
}